export const COUPONS_PAGE_SIZE = 20;

export const DEFAULT_COUPON_PERIOD_MONTHS = 1;

export const DEFAULT_DISCOUNT_PERCENT = 10;

export const DEFAULT_TOTAL_USAGES_LIMIT = 1;
